import { h } from 'preact';
import PureComponent from './PureComponent';
import { select, scaleLinear, scaleBand, scaleSequential, axisBottom, axisLeft, stack, line, area } from 'd3';
import { union, index } from 'd3-array';

const P = {
  height: 70,
  barHeight: 13.5,
  margin : { t: 30, r: 15, b: 18, l: 15 },
  colors: {
    blue: "#1675b0",
    red: "#d64946",
    black: "#333333",
    gray: "#d3d3d3"
  }
}

class DistrictStatsPrevResults extends PureComponent {
  constructor() {
    super();
  }

  setUpData(stats) {
    const data = [
      {
        cat: "v",
        value: stats['total_g_turnout'],
        start: 0,
        color: P.colors.black
      },
      {
        cat: "nv",
        value: 100 - (stats['total_g_turnout']),
        start: stats['total_g_turnout'],
        color: P.colors.gray
      },
    ]

    return(data);
  }

  setUpSvg(width) {
    const { district, slug } = this.props;
    const id = `district-stats__prev_results__${slug}-${district}`

    const svg = select(`#${id}`).select('svg')
    svg.attr('width', width)
      .attr('height', P.height)
  }

  setScale(width) {
    const xScale = scaleLinear()
      .domain([0, 100])
      .range([P.margin.l, width - P.margin.r]);

    return(xScale);
  }

  drawAxis(width, xScale) {
    const { district, slug } = this.props;

    const id = `district-stats__prev_results__${slug}-${district}`

    const xAxisG = select(`#${id}`).select(".x-axis");

    const xAxis = axisBottom(xScale)
      .ticks(5)
      .tickFormat(d => d == 100 ? '100%' : d == 0 ? 0 : "")
      .tickSize(- (P.barHeight + 4))

    xAxisG
      .attr('transform', `translate(0, ${P.height - P.margin.b + 4})`)
      .call(xAxis)
  }

  drawBars(width, xScale, data) {
    const { district, slug } = this.props;

    const id = `district-stats__prev_results__${slug}-${district}`

    const barsG = select(`#${id}`).select('.bars')
      .attr('transform', `translate(0, ${P.height - P.margin.b - P.barHeight})`)

    barsG.selectAll('rect')
      .data(data)
      .join('rect')
      .attr('x', d => xScale(d.start))
      .attr('y', 0)
      .attr('width', d => xScale(d.value) - xScale(0))
      .attr('height', P.barHeight)
      .attr('fill', d => d.color)
      .attr('data-width', d => xScale(d.value))
      .attr('fill-opacity', 0.8)
  }

  drawLabels(width, xScale, stats) {
    const { district, slug } = this.props;

    const id = `district-stats__prev_results__${slug}-${district}`

    const topLabelsG = select(`#${id}`)
      .select('.labels__top')
      .attr('transform', `translate(${xScale(stats['total_g_turnout'])}, ${P.height - P.margin.b - P.barHeight})`);
    const bottomLabelsG = select(`#${id}`)
      .select('.labels__bottom')
      .attr('transform', `translate(${xScale(25.4)}, ${P.height - P.margin.b})`);

    // marker
    topLabelsG.select('polygon')
      .attr('points', "0,0 -5,-8.5 5,-8.5")
      .attr('fill', 'black')
      .attr('stroke-width', 0)

    const topLabelsText = topLabelsG.select('text')
      .attr('y', -30)
      .attr('text-anchor', 'middle')

    topLabelsText.selectAll('tspan').remove();

    topLabelsText.append('tspan')
      .attr('x', 0)
      .text('District turnout:')
      .style('font-size', '10px')

    topLabelsText.append('tspan')
      .attr('x', 0)
      .attr('dy', 15)
      .text(`${Math.round(stats['total_g_turnout'] * 10) / 10}%`)
      .style('font-weight', 'bold')

  }

  componentDidMount() {
    const { stats, width } = this.props;

    const data = this.setUpData(stats);
    this.setUpSvg(width);
    const xScale = this.setScale(width);
    this.drawAxis(width, xScale);
    this.drawBars(width, xScale, data);
    this.drawLabels(width, xScale, stats);
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const { stats, width } = this.props;

      const data = this.setUpData(stats);
      this.setUpSvg(width);
      const xScale = this.setScale(width);
      this.drawAxis(width, xScale);
      this.drawBars(width, xScale, data);
      this.drawLabels(width, xScale, stats);
    }
  }

  render() {
    const { slug, district } = this.props;
    const { width } = this.state;

    const id = `district-stats__prev_results__${slug}-${district}`

    return (
      <div id={id}>
        <svg>
          <g class="axes">
            <g class="x-axis"></g>
          </g>
          <g class="bars"></g>
          <g class="labels">
            <g class="labels__top">
              <polygon></polygon>
              <text></text>
            </g>
            <g class="labels__bottm"></g>
          </g>
        </svg>
      </div>
    );
  }
}

export default DistrictStatsPrevResults;